export default "__VITE_ASSET__C$QHPWoe__"